import axios from "axios";
import { invoice, report } from "../../api";

const apiUrl = report;

//============================================total=====================================================================
export function loadTotalData(year) {
  return axios.get(`${apiUrl}/data/total/${year}`);
}
export function loadQuarterCollectionData(year) {
  return axios.get(`${apiUrl}/data/quarter/${year}`);
}
export function loadCategoryCollectionData(year) {
  return axios.get(`${apiUrl}/data/collection/category/${year}`);
}

//=================================================report invoice=======================================================
export function loadReportInvoice(
  pageLimit,
  page,
  year,
  date,
  status,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/all/invoice?limit=${pageLimit}&offset=${page}&financial_year__id=${year}&created_at__range=${date}&status_code__in=${status}&search=${search}&ordering=${order}`,
  );
}

export function loadAdmissionInvoiceReport(
  pageLimit,
  page,
  year,
  date,
  status,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/admission/invoice?limit=${pageLimit}&offset=${page}&financial_year__id=${year}&created_at__range=${date}&status_code__in=${status}&search=${search}&ordering=${order}`,
  );
}

export function loadStudentInvoiceReport(
  pageLimit,
  page,
  year,
  date,
  status,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/student/invoice?limit=${pageLimit}&offset=${page}&financial_year__id=${year}&created_at__range=${date}&status_code__in=${status}&search=${search}&ordering=${order}`,
  );
}

export function loadStaffInvoiceReport(
  pageLimit,
  page,
  year,
  date,
  status,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/staff/invoice?limit=${pageLimit}&offset=${page}&financial_year__id=${year}&created_at__range=${date}&status_code__in=${status}&search=${search}&ordering=${order}`,
  );
}

export function loadCustomerInvoiceReport(
  pageLimit,
  page,
  year,
  date,
  status,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/customer/invoice?limit=${pageLimit}&offset=${page}&financial_year__id=${year}&created_at__range=${date}&status_code__in=${status}&search=${search}&ordering=${order}`,
  );
}

export function loadBoardInvoiceReport(
  pageLimit,
  page,
  year,
  date,
  status,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/board/invoice?limit=${pageLimit}&offset=${page}&financial_year__id=${year}&created_at__range=${date}&status_code__in=${status}&search=${search}&ordering=${order}`,
  );
}

//=================================================report invoice payment=======================================================
export function loadPaymentLogsReportInvoice(
  pageLimit,
  page,
  date,
  search,
  order,
) {
  return axios.get(
    `${apiUrl}/payment/collection?limit=${pageLimit}&offset=${page}&created_at__range=${date}&search=${search}&ordering=${order}`,
  );
}

//=================================================report invoice payment=======================================================
export function loadSuzaIncomeReport() {
  return axios.get(`${apiUrl}/suza/collection`);
}

export function loadSuzaIncomeReportDate(start_date, end_date) {
  return axios.get(
    `${apiUrl}/suza/collection?start_date=${start_date}&end_date=${end_date}`,
  );
}

//=================================================report invoice payment=======================================================
export function loadCenterIncomeReport(center) {
  return axios.get(`${apiUrl}/collection/center/${center}`);
}

export function loadCenterIncomeReportDate(center, start_date, end_date) {
  return axios.get(
    `${apiUrl}/collection/center/${center}?start_date=${start_date}&end_date=${end_date}`,
  );
}

//=================================================report invoice payment=======================================================
export function loadAccountIncomeReport(account, limit, offset) {
  return axios.get(
    `${apiUrl}/account/collection/${account}?transactions_per_page=${limit}&page=${offset}`,
  );
}

export function loadAccountIncomeReportDate(
  account,
  limit,
  offset,
  start_date,
  end_date,
) {
  return axios.get(
    `${apiUrl}/account/collection/${account}?transactions_per_page=${limit}&page=${offset}&start_date=${start_date}&end_date=${end_date}`,
  );
}

//=================================================report invoice payment=======================================================
export function loadFullPaymentReport(type, page, pageSize, search, order) {
  const params = new URLSearchParams({
    type: type,
    page: page,
    page_size: pageSize,
  });

  return axios.get(`${apiUrl}/full-payment?${params.toString()}`);
}

export function loadExceesPaymentReport(type, page, pageSize, search, order) {
  const params = new URLSearchParams({
    type: type,
    page: page,
    page_size: pageSize,
  });

  return axios.get(`${apiUrl}/excess-payment?${params.toString()}`);
}

export function loadUnpaidReport(type, page, pageSize, search, order) {
  const params = new URLSearchParams({
    type: type,
    page: page,
    page_size: pageSize,
  });

  return axios.get(`${apiUrl}/unpaid-invoice?${params.toString()}`);
}

//=================================================report invoice payment=======================================================
export function loadStudentInvoiceDataReport(data) {
  return axios.post(`${apiUrl}/student/invoice/report`, data);
}
